import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FeedRating } from '@app/model/feedsRating';
import { Product } from '@app/model/product';
import { FeedsService } from '@app/services/feeds/feeds.service';
import { LoaderService } from '@app/services/loader/loader.service';
import { PaymentService } from '@app/services/Payment/payment.service';
import { environment } from '../../../../../environments/environment.prod';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {

  @Input('productData') product!: Product;
  
  constructor(
    private router: Router,
    private feedsService: FeedsService,
    private paymentService: PaymentService
  ) { }

  productInfoId: any;
  userInfoId: any;
 
  feedList:any;
  feedTotal:any;
  feedAvg:any;


  productPrice:any;
  productDiscount :any;
  finalDiscount :any;

  serverImgUrl= environment.IMG_URL;

  ngOnInit() {
    //console.log(this.product);
    this.productInfoId = this.product.sellProductInfoId
    this.userInfoId = this.product.userInfoId
    this.fetchFeedsByProduct();
    
    this.productPrice = this.product.sellProductPrice;
    this.productDiscount = this.product.sellProductDiscount;
    this.finalDiscount= this.productPrice -((this.productPrice * this.productDiscount) / 100)
  }
  
  fetchFeedsByProduct(): void {
    this.feedsService.fetchFeedsByProduct(this.userInfoId, this.productInfoId)
      .subscribe({
        next: (p) => {
          this.feedList = p as FeedRating;
          this.feedTotal = this.feedList.data.length;
          var sum = 0;
          if (this.feedList.data != null && this.feedList.data.length > 0) {
            for (var i = 0; i < this.feedList.data.length; i++) {
              sum += this.feedList.data[i].feedRating;
            }
            this.feedAvg = sum / this.feedList.data.length;
          }
          else {
            this.feedAvg = 0; 
          }
        }
      });
  }

  addToCart(product: Product) {
    // Implement your cart logic here
    console.log('Product added to cart:', product);
    //localStorage.setItem('cart', JSON.stringify(product));
    this.paymentService.addToCart(product);
    debugger
  }
}
